var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrullLogoPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 41,
    viewBox: "0 0 78 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_992_2623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5181 -9.02585e-09L14.5181 18.7871L8.62442 18.7871L8.62442 5.89364L5.87636 5.89364L5.87636 34.5668L8.62442 34.5668L8.62442 21.5524L14.5181 21.5524L14.5181 40.4604L11.8737 40.4604L8.6417 37.8679L5.94549 40.4604L2.51542e-08 40.4604L2.76148e-09 4.44183C1.23568e-09 1.98759 1.98759 -1.23568e-09 4.44183 -2.76148e-09L14.5181 -9.02585e-09Z",
    fill: "#B27EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2829 0L31.801 -9.0366e-09L31.801 17.2834L29.1566 20.2043L31.801 23.177L31.801 40.4604L25.9073 40.4604L25.9073 23.1598L23.1593 23.1598L23.1593 40.4432L17.2656 40.4432L17.2656 0L17.2829 0ZM23.1765 17.2834L25.9246 17.2834L25.9246 5.89364L23.1765 5.89364L23.1765 17.2834Z",
    fill: "#B27EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0845 -9.02585e-09L49.0845 40.4432L34.5664 40.4432L34.5664 0L40.46 -3.66407e-09L40.46 34.5668L43.2081 34.5668L43.2081 -5.37253e-09L49.1017 -9.0366e-09L49.0845 -9.02585e-09Z",
    fill: "#B27EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.832 0L57.7257 -3.66407e-09L57.7257 34.5668L74.8017 34.5668L74.8017 36.5198C74.8017 38.6975 73.0388 40.4604 70.8611 40.4604L51.832 40.4604L51.832 0Z",
    fill: "#B27EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2656 0L66.1593 -3.66407e-09L66.1593 26.4609L74.801 26.4609L74.801 32.3545L60.2829 32.3545L60.2829 0L60.2656 0Z",
    fill: "#B27EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5273 0L68.5273 24.5251L77.9986 12.2539L68.5273 0Z",
    fill: "#B27EE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_992_2623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 40.4432,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrullLogoPurple);
export default __webpack_public_path__ + "static/media/grullLogoPurple.cd1746f4da3a7ad0587f7c742d3d84bf.svg";
export { ForwardRef as ReactComponent };